import { render, staticRenderFns } from "./GarbageJobPage.vue?vue&type=template&id=44d450f1"
import script from "./GarbageJobPage.vue?vue&type=script&lang=js"
export * from "./GarbageJobPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports